import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import FormattedDateOrDashes from '../../../../components/FormattedDateOrDashes';
import snapshotMessages from '../messages';
import { useDesiredMoveInDateRow } from './hooks';

type Props = {
  organizationId: string,
  propertyId: string,
  prospectId: string,
  moveInDateFrom: ?(string | Object),
  onSaved?: () => void,
};

const DesiredMoveInDateRow = (props: Props) => {
  const { canEdit, savedDate, pickerResetKey, datePickerProps } =
    useDesiredMoveInDateRow(props);

  return (
    <li
      data-testid="desiredMoveInDate"
      style={{ display: 'flex', alignItems: 'center', columnGap: 8 }}
    >
      <FormattedMessage {...snapshotMessages.desiredMoveInDate} />
      {canEdit ? (
        <DatePicker
          key={pickerResetKey}
          {...datePickerProps}
          fullWidth={false}
          sx={{ width: 180 }}
        />
      ) : (
        <FormattedDateOrDashes value={savedDate} format="MMM DD, YYYY" />
      )}
    </li>
  );
};

export default DesiredMoveInDateRow;
